const API = "https://jm.komerzy.com/backend/routes/api.php?url=categoriaapi";

// LISTAR
export const getCategorias = async () => {

    const response = await fetch(`${API}&action=listar`);

    const data = await response.json();

    return data.data;
};

// GUARDAR
export const guardarCategoria = async (categoria) => {

    const response = await fetch(`${API}&action=registrar`, {

        method: 'POST',

        headers: {
            'Content-Type': 'application/json'
        },

        body: JSON.stringify(categoria)
    });

    return await response.json();
};

// ACTUALIZAR
export const actualizarCategoria = async (categoria) => {

    const response = await fetch(`${API}&action=actualizar`, {

        method: 'PUT',

        headers: {
            'Content-Type': 'application/json'
        },

        body: JSON.stringify(categoria)
    });

    return await response.json();
};

// ELIMINAR
export const eliminarCategoria = async (categoria) => {

    const response = await fetch(`${API}&action=eliminar`, {

        method: 'PUT',

        headers: {
            'Content-Type': 'application/json'
        },

        body: JSON.stringify(categoria)
    });

    return await response.json();
};